import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

let messagingInstance = null;

export const initFirebase = async (config) => {
    if (!config || !config.apiKey) return null;
    if (!(await isSupported())) return null;

    const app = initializeApp(config);
    messagingInstance = getMessaging(app);
    return messagingInstance;
};

export const getFcmToken = async (vapidKey) => {
    if (!messagingInstance) return null;

    if (Notification.permission === 'default') {
        const result = await Notification.requestPermission();
        if (result !== 'granted') return null;
    }
    if (Notification.permission !== 'granted') return null;

    const registration = await navigator.serviceWorker.ready;
    return getToken(messagingInstance, {
        vapidKey,
        serviceWorkerRegistration: registration,
    });
};

export const onForegroundMessage = (handler) => {
    if (!messagingInstance) return () => {};
    return onMessage(messagingInstance, handler);
};
